import { AppTour } from '../tour.model';

export const BUILD_REPORT_WIZARD_TOUR: AppTour = {
  tourId: 'build-report-wizard-tour',
  showProgress: true,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'build-report-wizard-step1-tour',
      attachTo: { element: '#step-guide-1', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_report_wizard_step1_title',
      text: 'tour_report_wizard_setp1_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep1SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep1SetupClick'}
       ]
     },
     {
      id: 'build-report-wizard-step2-tour',
      attachTo: { element: '#step-guide-2', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_report_wizard_step2_title',
      text: 'tour_report_wizard_step2_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep2SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep2SetupClick'}
       ]
     } 
   ]
};


export const BUILD_REPORT_TITLE_DATE_PANEL_TOUR: AppTour = {

  tourId: 'build-report-title-date-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true,
    classes: 'tooltip-guide'
  },
  steps: [
    {
      id: 'button-add-category-tour',
      attachTo: { element: '#title-date-report-control-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_report_date_formate_title',
      text: 'tour_report_date_formate_text',
      parallel: true
     }
   ]
};

export const CUSTOMISE_REPORT_PANEL_TOUR: AppTour = {

  tourId: 'customise-report-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: true, classes: 'tooltip-guide'},
  steps: [
    {
      id: 'add-report-fields-section-tour',
      attachTo: { element: '.add-report-fields-section-guide', on: 'right' },
      cancelIcon: {enabled: false},
      title: 'customise_report_tour1_title',
      text: 'customise_report_tour1_text',
      parallel: true
     },
     {
      id: 'edit-report-field-guide',
      attachTo: { element: '.edit-report-field-guide', on: 'left' },
      cancelIcon: {enabled: false}, 
      title: 'customise_report_tour2_title',
      text: 'customise_report_tour2_text',
      parallel: true
     },
      {
      id: 'drag-report-field-guide',
      attachTo: { element: '.drag-report-field-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'customise_report_tour3_title',
      text: 'customise_report_tour3_text',
      parallel: true
     },
   ]
};
